// The Notes Hub pages the notes list in and appends each page to what it
// already holds. A page can repeat rows the list has — the API pages by offset,
// so a note added or removed between two requests shifts the window — and a
// repeated row must not appear twice in the hub or count towards the drain's
// progress. The de-dupe therefore has to be the same one in two places: the
// `courses/appendAllNotes` mutation that ships it, and the fetch stub in
// tests/unit/courses/NotesHubDrain.spec.js that stands in for the store while
// the walk is exercised. Two hand-rolled copies drift; this is the one copy
// both call. #1524.

/**
 * Append a page of notes to a list, dropping rows whose id the list already
 * holds. Pure: neither argument is mutated, and the result is a new array.
 *
 * @param {Array<{id: *}>} existing notes already held, in display order.
 * @param {Array<{id: *}>|null|undefined} incoming the page just fetched; a
 *   missing page is treated as an empty one, which is what a failed fetch and
 *   an exhausted list both look like to the caller.
 * @returns {Array<{id: *}>} a new list: `existing`, then the unseen rows of
 *   `incoming` in the order they arrived.
 */
export function appendNotesById(existing, incoming) {
  const seen = new Set(existing.map(n => n.id));
  const fresh = (incoming || []).filter(n => !seen.has(n.id));
  return [...existing, ...fresh];
}
